import { useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";

import { SubmitButton as Button } from "~/components/form/submit-button";
import RolesModal from "./role-selection";
import { useAuth } from "~/hooks/TGEPE/use-auth";
import { loginRoute } from "~/pages/all-routes";
import { getTokens } from "~/services/auth.services";
// Import decodeJWToken is no longer needed as we're parsing the token directly
import { encryptData } from "~/utils/crypto";

const LoginComponent = () => {
  const {
    idToken: userToken,
    loginHandler: login,
    updateRefreshToken,
  } = useAuth();
  const { code: idToken } = loginRoute.useSearch();
  console.log(idToken);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roles, setRoles] = useState<string[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    async function getData() {
      const url = new URL(window.location.href);
      const fullPath = url.href;
      const hashIndex = fullPath.indexOf("#");
      const codeIndex = fullPath.indexOf("code=");

      if (codeIndex > -1 && (hashIndex === -1 || codeIndex < hashIndex)) {
        const code = fullPath.substring(codeIndex + 5);
        console.log(code);
        setLoading(true);
        const response = await getTokens(code);

        if ("data" in response && response.status) {
          const data = response.data as Record<string, any>;
          if (!data || !data.id_token || !data.refresh_token) {
            console.error("Invalid token data received:", data);
            setLoading(false);
            return;
          }

          const id_token = data.id_token as string;
          const refresh_token = data.refresh_token as string;

          try {
            // Validate token format
            const tokenParts = id_token.split(".");
            if (tokenParts.length !== 3) {
              console.error("Invalid token format");
              setLoading(false);
              return;
            }

            // Parse and validate token payload
            const payload = JSON.parse(atob(tokenParts[1]));
            if (!payload || !payload["cognito:groups"]) {
              console.error("Invalid token payload:", payload);
              setLoading(false);
              return;
            }

            // Set token in auth context
            login(id_token);

            // Clear existing storage and store new tokens
            localStorage.clear();
            localStorage.setItem("id_token", encryptData(id_token));
            localStorage.setItem("refresh_token", encryptData(refresh_token));
            console.log("payload:", payload);
            const expires_in = payload["exp"];
            console.log("expires_in:", expires_in);
            // Store token expiry time from the exp claim
            const expiryTime = payload["exp"];
            if (expiryTime) {
              localStorage.setItem("token_expiry", expiryTime.toString());
              console.log(
                "Token expiry set to:",
                new Date(expiryTime * 1000).toISOString(), // Convert seconds to milliseconds
                "Raw timestamp:",
                expiryTime
              );
            }

            // Extract roles from token
            const tokenRoles: string[] = payload["cognito:groups"];

            // Clean up URL by removing the code parameter
            const newUrl = fullPath
              .replace(/code=[^&]*&?/, "")
              .replace(/\?$/, "");
            window.history.replaceState({}, document.title, newUrl);

            // Update state
            setRoles(tokenRoles);
            setLoading(false);
            setIsModalOpen(true);
          } catch (error) {
            console.error("Error processing token:", error);
            setLoading(false);
          }
        } else {
          console.error("Error:", response);
        }
      }
      if (idToken == null && userToken == null) {
        navigate({ to: loginRoute.path });
      }
    }

    void getData();

    return () => { };
  }, [idToken, login, navigate, updateRefreshToken, userToken]);

  const exploreButtonHandler = () => {
    console.log(process.env);
    window.location.href = process.env.VITE_COGNITO_POOL_LOGIN_URL!;
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div
      className="flex justify-center items-center h-screen bg-cover bg-center"
      style={{ backgroundImage: "url('/images/Malkomlogin.jpeg')" }}
    >
      {loading && (
        <div className="absolute inset-0 bg-white flex justify-center items-center z-50">
          <div className="spinner-border animate-spin border-4 border-orange-400 border-t-transparent w-12 h-12 rounded-full"></div>
        </div>
      )}
      {isModalOpen && roles.length > 0 && (
        <RolesModal roles={roles} onClose={closeModal} />
      )}
      <div className="absolute left-20 bg-white bg-opacity-80 rounded-lg shadow-lg p-6 transform hover:scale-105 transition-transform duration-300">
        {/* <h1 className="text-5xl font-bold text-center text-blue-600 mb-4">
          MALKOM
        </h1> */}
        <div className="p-5">
          <img
            src="/images/malkomAI_black.png"
            className="max-w-full max-h-full"
            width={250}
            height={250}
            alt=""
          ></img>
        </div>
        <Button
          variant={"primary"}
          onClick={exploreButtonHandler}
          className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 rounded"
        >
          Log In
        </Button>
      </div>
      <div className="absolute bottom-1 left-1/2 -translate-x-1/2 bg-white bg-opacity-80 rounded-lg shadow-lg p-2 w-11/12 text-xs text-justify text-sm" style={{ "width": "98%" }}>
        <div>
          <span className="font-bold">Disclaimer:</span> These services use Artificial Intelligence (AI) to generate responses and assist in delivering outputs. While human-in-the-loop may be involved in the process, AI outputs may contain limitations, inaccuracies, or errors. An independent validation is recommended before relying on system-generated outputs.
        </div>
      </div>

    </div>
  );
};

export default LoginComponent;
